import { Grid, makeStyles } from '@material-ui/core'
import DazzedHeadingForGrid from 'components/common/text/DazzedHeadingForGrid'
import React from 'react'
import EngagementWidgetSkeleton from './EngagementWidgetSkeleton'
import ComingSoon from './ComingSoon'

const useStyles = makeStyles(theme => ({
  root: props => ({
    // padding: 10,
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '100%',
    padding: 15,
    paddingBottom: 0,

    [theme.breakpoints.up('sm')]: {
      padding: 15,
      paddingBottom: 0
    },
    [theme.breakpoints.up('md')]: {
      padding: 15,
      paddingBottom: 0
    },
    [theme.breakpoints.up('lg')]: {
      padding: 25,
      paddingBottom: 0
    },
    [theme.breakpoints.up('xl')]: {
      padding: 25,
      paddingBottom: 0
    }
  }),
  comingSoonContainer: {
    justifyContent: 'space-around !important'
  },
  scoreOptionsContainer: {
    maxWidth: 350,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-evenly'
  },
  scoreItem: {
    width: '33.33%'
  },
  description: {
    color: '#727B8C',
    padding: '0px 0px'
  }
}))

const EngagementWidget = ({ title, scoreOptions, selectedScore, isLoading, comingSoon = false }) => {
  const classes = useStyles()

  return isLoading ? (
    <EngagementWidgetSkeleton />
  ) : comingSoon ? (
    <Grid container direction="column" className={[classes.root, classes.comingSoonContainer].join(' ')}>
      <Grid item>
        <DazzedHeadingForGrid regular xs={14} sm={14} md={14} lg={16} xl={16}>
          {title}
        </DazzedHeadingForGrid>
      </Grid>
      <Grid item>
        <ComingSoon />
      </Grid>
    </Grid>
  ) : (
    <Grid container direction="column" className={classes.root}>
      <Grid item>
        <DazzedHeadingForGrid regular xs={14} sm={14} md={14} lg={16} xl={16}>
          {title}
        </DazzedHeadingForGrid>
      </Grid>
      <Grid container className={classes.scoreOptionsContainer}>
        {scoreOptions.map((option, index) => (
          <Grid key={index} item className={classes.scoreItem}>
            <Grid container key={index} direction="column" alignItems="center" justifyContent="center">
              <Grid item>
                {React.createElement(option.icon, {
                  fillColor: option.key === selectedScore.key ? selectedScore.fillColor : undefined,
                  strokeColor: option.key === selectedScore.key ? selectedScore.strokeColor : undefined
                })}
              </Grid>
              <Grid item>
                <DazzedHeadingForGrid
                  semibold={option.key !== selectedScore.key}
                  xs={13}
                  sm={13}
                  md={13}
                  lg={15}
                  xl={15}
                  style={{
                    color: selectedScore.key === option.key ? selectedScore.strokeColor : '#C6C6C6',
                    textAlign: 'center'
                  }}
                >
                  {option.label}
                </DazzedHeadingForGrid>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
      <Grid item>
        <DazzedHeadingForGrid
          regular
          xs={11}
          sm={11}
          md={11}
          lg={14}
          xl={14}
          style={{ color: '#727B8C', padding: '0px 10px' }}
        >
          {selectedScore.description}
        </DazzedHeadingForGrid>
      </Grid>
    </Grid>
  )
}

export default EngagementWidget
